import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { localeNamespaces, localeResources } from "./locale-resources";

export const SUPPORTED_LANGUAGES = ["en", "es", "fr", "de", "zh"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  zh: "中文",
};

export const LANGUAGE_FLAGS: Record<SupportedLanguage, string> = {
  en: "🇺🇸",
  es: "🇪🇸",
  fr: "🇫🇷",
  de: "🇩🇪",
  zh: "🇨🇳",
};

// Initialize i18next
const initI18n = () => {
  i18next.use(LanguageDetector).init({
    resources: localeResources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "common",
    ns: localeNamespaces,

    // Language detection options
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes
    },

    // React options
    react: {
      useSuspense: true,
    },

    // Use natural English strings as keys
    keySeparator: false, // Keys are natural text, no nested structure
    nsSeparator: false, // Namespace is passed via useTranslation(ns), not in the key
  });

  return i18next;
};

export const i18nInstance = initI18n();
export default i18nInstance;
